export default {
	methods: {
		_getPrevisaoTempo(callback, cidade, estado, index) {
			this._httpGet('Servico/get_tempo_cidade/' + cidade + '/' + estado, (retorno) => {
				let r = {
					temperatura: 'N/A',
					cidade: 'N/A',
					estado: 'N/A',
					vento: 'N/A',
					clima: 'N/A',
					climaCodigo: 'N/A',
					img: 'N/A',
					porDoSol: 'N/A',
					nascerDoSol: 'N/A',
					umidade: 'N/A',
					thumb: 'N/A',
					index: 'N/A'
				}
				if (retorno._request && retorno._status) {
					if (!retorno.data.error) {
						r.temperatura = retorno.data.results.temp + 'ºC'
						r.cidade = retorno.data.results.city_name
						r.estado = estado
						r.vento = (Number(Number(retorno.data.results.wind_speedy.replace('km/h', ''))) * 0.869).toFixed(2) + ' Kt'
						r.clima = retorno.data.results.description
						r.climaCodigo = retorno.data.results.condition_code
						r.img = 'https://s.yimg.com/zz/combo?a/i/us/nws/weather/gr/' + retorno.data.results.condition_code + 'd.png'
						r.porDoSol = retorno.data.results.sunset
						r.nascerDoSol = retorno.data.results.sunrise
						r.umidade = retorno.data.results.humidity + '%'
						r.thumb = 'https://s.yimg.com/zz/combo?a/i/us/nws/weather/gr/' + retorno.data.results.condition_code + 'ds.png'
						//r.// updated = weather.updated
						r.index = index
					}

					callback(r)
				}
			})
		}
	}
}